import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import { connect } from 'react-redux';
import { compose } from "recompose";
import { withCookies } from 'react-cookie';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';
import grey from '@material-ui/core/colors/grey';

import IntegrationReactSelect from '../Common/IntegrationReactSelect';
import Enemy from '../Game/Enemy';
import { userActions, projectActions, tasksissuesActions } from '../../_actions';
import Progress from '../Common/Progress';

const imageUrl_SpiderWeb01 = require(`../../images/GameTheme/Background/Spiderweb01.png`)
const imageUrl_SpiderWeb03 = require(`../../images/GameTheme/Background/Spiderweb03.png`)
const imageUrl_KULO4 = require(`../../images/GameTheme/Background/KULO_04.png`)
const imageUrl_Statue01 = require(`../../images/GameTheme/Background/statue01.png`)
const imageUrl_SenceFloor = require(`../../images/GameTheme/Background/sence_floor.png`)

const formatter1 = 'YYYY-MM-DD';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '80%',
        maxHeight: '80%',
        overflow: 'auto',
        [theme.breakpoints.up('lg')]: {
            width: '60%',
        },
        [theme.breakpoints.down('sm')]: {
            height: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    //RadioGroup
    formControl: {
        margin: theme.spacing.unit,
    },
    group: {
        flexDirection: 'row',
    },
    greenRoot: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redRoot: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    yellowRoot: {
        color: yellow[600],
        '&$checked': {
            color: yellow[500],
        },
    },
    greyRoot: {
        color: grey[600],
        '&$checked': {
            color: grey[500],
        },
    },
    root: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        width: 'auto',
        height: 'auto',
    },
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
    checked: {
    }
});

function getModalStyle(checkedGameTheme) {
    const top = 50;
    const left = 50;

    if (checkedGameTheme) {
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
            backgroundImage: `url(${imageUrl_SenceFloor})`,
            backgroundPosition: 'left 101%',
            backgroundRepeat: 'repeat-x',
            backgroundSize: '30%'
        }
    }
    else {
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        }
    }
}

class FormComponent extends Component {
    constructor(props) {
        super(props);

        var now = new Date();
        var dateTime = moment(now).format(formatter1);

        this.state = {
            mode: 'ADD',
            modalTitle: 'Create Project Task',
            taskId: '',

            assignedToId: '',
            taskName: '',
            taskNotes: '',
            projectId: 0,
            status: 1,
            startDateTime: dateTime,
            endDateTime: dateTime,
            duration: 0,
            taskType: 'Task',
            actualFinishDate: dateTime,

            taskNameValid: true,
            taskNotesValid: true,
            projectIdValid: true,
            statusValid: true,
            startDateTimeValid: true,
            durationValid: true,
            assignedToIdValid: true,
            openProgress: false
        };
    }

    componentDidMount() {
        this.props.dispatch(userActions.getAll());
        this.props.dispatch(projectActions.getAllByUserId(this.props.user.id));
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.open !== nextProps.open) {
            if (nextProps.TaskId) {
                const tasksissues = nextProps.tasksissues;
                var tasksissuesData = tasksissues.items && tasksissues.items.find(function (item) {
                    return item.TaskId === nextProps.TaskId;
                });

                if (tasksissuesData) {
                    this.setState({
                        assignedToId: tasksissuesData.AssignedToId,
                        taskId: tasksissuesData.TaskId,
                        taskName: tasksissuesData.TaskName,
                        taskNotes: tasksissuesData.TaskNotes,
                        projectId: tasksissuesData.ProjectId,
                        status: tasksissuesData.Status.toString(),
                        startDateTime: moment(tasksissuesData.StartDate).format(formatter1),
                        endDateTime: moment(tasksissuesData.EndDate).format(formatter1),
                        duration: tasksissuesData.Duration,
                        taskType: tasksissuesData.TaskType,
                        actualFinishDate: moment(tasksissuesData.ActualFinishDate).format(formatter1),

                        mode: 'EDIT',
                        modalTitle: tasksissuesData.TaskType === 'PreTask'
                            ? 'Edit Pre-Sales Task'
                            : tasksissuesData.TaskType === 'Task'
                                ? 'Edit Project Task'
                                : 'Edit Project Issue',
                    })
                }
            }
            else if (nextProps.ProjectId && nextProps.ProjectId !== '') {
                this.setState({
                    projectId: Number(nextProps.ProjectId)
                })
            }
            else {
                this.cleanData();
            }
        }
    }

    handleChange = name => event => {
        if (name === 'duration') {
            if (event.target.value % 0.25 !== 0) {
                //alert('Duration must be an increment of 0.25')
                this.setState({
                    durationValid: false
                })
            }
            else if (event.target.value < 0) {
                //alert('Duration must be no less than 0.25')
                this.setState({
                    durationValid: false
                })
            }
            else if (event.target.value > 999) {
                //alert('Duration must be no greater than 999')
                this.setState({
                    durationValid: false
                })
            }
            else {
                this.setState({
                    [name + 'Valid']: true,
                });
            }

            this.setState({
                endDateTime: moment(addWeekdays(this.state.startDateTime, event.target.value - 1)._d).format(formatter1),
            });
        }
        else if (name === 'startDateTime') {
            this.setState({
                endDateTime: moment(addWeekdays(event.target.value, this.state.duration - 1)._d).format(formatter1),
            });
        }
        else {
            this.setState({
                [name + 'Valid']: true,
            });
        }

        if (name === 'taskType') {
            const method = this.state.mode === 'ADD' ? 'Create' : 'Edit';
            this.setState({
                modalTitle: event.target.value === 'PreTask'
                    ? method + ' Pre-Sales Task'
                    : event.target.value === 'Task'
                        ? method + ' Project Task'
                        : method + ' Project Issue',
            })

            this.setState({
                projectIdValid: true
            })
        }

        this.setState({
            [name]: event.target.value
        });
    };

    handleClose = () => {
        this.props.close()
        this.cleanData()
    }

    handleSave = () => {
        let valid = true;

        if (this.state.taskName === '') {
            this.setState({
                taskNameValid: false
            })
            valid = false;
        }
        if (this.state.taskNotes === '') {
            this.setState({
                taskNotesValid: false
            })
            valid = false;
        }
        if (this.state.taskType !== 'PreTask' && this.state.projectId === 0) {
            this.setState({
                projectIdValid: false
            })
            valid = false;
        }

        if (this.state.startDateTime === '') {
            this.setState({
                startDateTimeValid: false
            })
            valid = false;
        }

        if (this.state.assignedToId === '') {
            this.setState({
                assignedToIdValid: false
            })
            valid = false;
        }

        if (this.state.status === '3' && moment(this.state.actualFinishDate).format(formatter1) === 'Invalid date') {
            this.setState({
                actualFinishDateValid: false
            })
            valid = false;
        }

        const DataProcessing = async () => {
            try {
                this.setState({
                    openProgress: true,
                })

                const inputData = {
                    "TaskId": this.state.taskId,
                    "AssignedToId": this.state.assignedToId,
                    "TaskName": this.state.taskName,
                    "TaskNotes": this.state.taskNotes,
                    "TaskType": this.state.taskType,
                    "ProjectId": this.state.projectId,
                    "Status": this.state.status,
                    "ActualFinishDate": this.state.status === '3' ? moment(this.state.actualFinishDate).format(formatter1) : null,
                    "StartDate": moment(this.state.startDateTime).format(formatter1),
                    "EndDate": this.state.endDateTime !== '' ? moment(this.state.endDateTime).format(formatter1) : moment(this.state.startDateTime).format(formatter1),
                    "Duration": this.state.duration !== '' ? this.state.duration : 0,
                    "OwnerId": this.props.user.id,
                    "CreatedUserId": this.props.user.id,
                    "UpdatedUserId": this.props.user.id,
                };

                if (this.state.mode === 'ADD') {
                    await this.props.dispatch(tasksissuesActions.insert(inputData));
                }
                else if (this.state.mode === 'EDIT') {
                    await this.props.dispatch(tasksissuesActions.update(inputData));
                }

                await this.props.dispatch(tasksissuesActions.getAllByProjectId(this.state.projectId));
                await this.handleClose();
            } catch (e) {
                console.error("Problem", e)
            }
        }

        if (valid) {
            DataProcessing();
        }
    }

    cleanData() {
        var now = new Date();
        var dateTime = moment(now).format(formatter1);

        this.setState({
            taskId: '',
            taskName: '',
            taskNotes: '',
            projectId: 0,
            status: 1,
            startDateTime: dateTime,
            endDateTime: dateTime,
            duration: 0,
            assignedToId: '',
            taskType: 'Task',

            taskNameValid: true,
            taskNotesValid: true,
            projectIdValid: true,
            statusValid: true,
            startDateTimeValid: true,
            durationValid: true,
            assignedToIdValid: true,

            mode: 'ADD',
            modalTitle: 'Create Project Task',
            openProgress: false
        });
    }

    handleSelectData = (data) => {
        if (data.type === 'Projects') {
            if (data.id) {
                this.setState({
                    projectId: data.id
                })
            }
        }
        else if (data.type === 'AssignedTo') {
            if (data.id) {
                this.setState({
                    assignedToId: data.id
                })
            }
        }
    }

    render() {
        const { classes, users, projects } = this.props;
        const checkedGameTheme = this.props.cookies.get('checkedGameTheme') === 'true' ? true : false || false;

        return (
            <Paper>
                <Progress openProgress={this.state.openProgress} />
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle(checkedGameTheme)} className={classes.paper}>

                        {checkedGameTheme && <RenderGameTheme />}

                        <Typography id="modal-title" style={{ fontSize: 40 }}>
                            {this.state.modalTitle}
                        </Typography>

                        {checkedGameTheme && <Enemy manday={this.state.duration} />}

                        <Grid container>
                            <Grid item sm={12} md={6}>
                                <FormLabel component="legend">*Type</FormLabel>
                                <RadioGroup
                                    aria-label="TaskType"
                                    name="taskType"
                                    className={classes.group}
                                    value={this.state.taskType}
                                    onChange={this.handleChange('taskType')}
                                >
                                    <FormControlLabel value="PreTask" control={<Radio />} label="Pre-Sales Task" />
                                    <FormControlLabel value="Task" control={<Radio />} label="Project Task" />
                                    <FormControlLabel value="Issue" control={<Radio />} label="Project Issue" />
                                </RadioGroup>
                                <TextField
                                    error={!this.state.taskNameValid}
                                    id="standard-name"
                                    label="*Task Name"
                                    className={classes.textField}
                                    value={this.state.taskName}
                                    onChange={this.handleChange('taskName')}
                                    margin="normal"
                                />
                                <TextField
                                    error={!this.state.taskNotesValid}
                                    multiline
                                    id="standard-multiline-static"
                                    label="*Notes"
                                    rows="7"
                                    className={classes.textField}
                                    value={this.state.taskNotes}
                                    onChange={this.handleChange('taskNotes')}
                                    margin="normal"
                                    variant="outlined"
                                />
                                <div style={{ marginTop: '40px' }} />
                                <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave}>
                                    Save
                                </Button>
                                <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                {
                                    this.state.mode === 'ADD' ? null :
                                        <FormControl component="fieldset" error={!this.state.statusValid} className={classes.formControl} hidden={this.state.mode === 'ADD'}>
                                            <FormLabel component="legend">*Status</FormLabel>
                                            <RadioGroup
                                                aria-label="Status"
                                                name="status"
                                                className={classes.group}
                                                value={this.state.status}
                                                onChange={this.handleChange('status')}
                                            >
                                                <FormControlLabel value="1" control={<Radio classes={{ root: classes.redRoot, checked: classes.checked }} />} label="Pending" />
                                                <FormControlLabel value="2" control={<Radio classes={{ root: classes.yellowRoot, checked: classes.checked }} />} label="In-progress" />
                                                <FormControlLabel value="3" control={<Radio classes={{ root: classes.greenRoot, checked: classes.checked }} />} label="Completed" />
                                                <FormControlLabel value="4" control={<Radio classes={{ root: classes.greyRoot, checked: classes.checked }} />} label="Cancelled" />
                                            </RadioGroup>
                                        </FormControl>
                                }
                                <IntegrationReactSelect
                                    disabledDefaultOptions={true}
                                    handleSelectData={this.handleSelectData}
                                    options={convertProjectsOptions(projects.items, this.props.user.departmentId)}
                                    valid={this.state.projectIdValid}
                                    value={this.state.projectId}
                                    placeholder={this.state.taskType === 'PreTask' ? 'Projects' : '*Projects'}
                                />
                                <Grid item sm={12} md={10}>
                                    <IntegrationReactSelect
                                        disabledDefaultOptions={true}
                                        handleSelectData={this.handleSelectData}
                                        options={convertAssignedToOptions(users.items)}
                                        valid={this.state.assignedToIdValid}
                                        value={this.state.assignedToId}
                                        placeholder='*Assigned To' />
                                    <TextField
                                        error={!this.state.startDateTimeValid}
                                        id="startDate"
                                        label="Start Date"
                                        type="date"
                                        className={classes.textField}
                                        value={this.state.startDateTime}
                                        onChange={this.handleChange('startDateTime')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <TextField
                                        error={!this.state.durationValid}
                                        id="standard-number"
                                        label="Man-Day"
                                        value={this.state.duration}
                                        onChange={this.handleChange('duration')}
                                        type="number"
                                        className={classes.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        margin="normal"
                                    />
                                    <TextField
                                        id="endDate"
                                        label="End Date"
                                        type="date"
                                        className={classes.textField}
                                        value={this.state.endDateTime}
                                        onChange={this.handleChange('endDateTime')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {this.state.mode === 'ADD' || this.state.status !== '3' ? null :
                                        <TextField
                                            error={!this.state.actualFinishDateValid}
                                            id="actualFinishDate"
                                            label="Actual Finish date "
                                            type="date"
                                            className={classes.textField}
                                            value={this.state.actualFinishDate}
                                            onChange={this.handleChange('actualFinishDate')}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <div style={{ paddingBottom: '50px' }} hidden={this.state.mode !== 'ADD'} />
                    </div>
                </Modal>
            </Paper>
        );
    }
}

function convertProjectsOptions(data, departmentId) {
    const options = data ? data.filter(function (item) {
        return item.ProgressStatus !== '4'
    }).map(data => ({
        label: data.ProjectName ? data.CompanyName + ' - ' + data.ProjectName : null + data.PipedriveJSON.title ? 'Deal Title: ' + data.PipedriveJSON.title : null,
        id: data.ProjectId,
        type: 'Projects'
    })) : [];

    return options
}

function convertAssignedToOptions(data) {
    const options = data ? data.filter(function (item) {
        return item.UserStatus === 'A'
    }).map(data => ({
        label: data.DepartmentId + ' - ' + data.UserName,
        id: data.UserId,
        type: 'AssignedTo'
    })) : [];

    return options
}

function addWeekdays(date, days) {
    date = moment(date);
    while (days > 0) {
        date = date.add(1, 'days');
        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
            days -= 1;
        }
    }
    return date;
}

function RenderGameTheme() {
    return (
        <div>
            <img alt="background" src={imageUrl_SpiderWeb01} style={{
                position: 'absolute',
                zIndex: '-2',
                top: '0px',
                right: '0px',
                height: '200px'
            }} />
            <img alt="background" src={imageUrl_SpiderWeb03} style={{
                position: 'absolute',
                zIndex: '-2',
                top: '0px',
                right: '120px',
                height: '80px'
            }} />
            <img alt="background" src={imageUrl_KULO4} style={{
                position: 'absolute',
                zIndex: '-2',
                bottom: '19px',
                right: '100px',
                height: '60px'
            }} />
            <img alt="background" src={imageUrl_Statue01} style={{
                position: 'absolute',
                zIndex: '-2',
                bottom: '29px',
                right: '7px',
                height: '180px',
            }} />
        </div>
    );
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, projects, tasksissues } = state;

    return {
        user,
        users,
        projects,
        tasksissues
    };
}

FormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(withCookies(FormComponent));


// WEBPACK FOOTER //
// ./src/components/TasksIssues/FormComponent.js